import React from 'react';
import BlockBase from '../../../../components/BlockBase/BlockBase';
import { block } from '../../../../utils';
const b = block('constructor-block');
export const ConstructorBlock = ({ data, children, }) => {
    const { anchor, visible, type } = data;
    return (React.createElement(BlockBase, { className: b({ type }), anchor: anchor, visible: visible, resetPaddings: data.resetPaddings }, children));
};
